import axios from "axios";
import { createContext, useContext, useState } from "react";
import { newBaseUrl } from "../Consts"

export const UsersContext = createContext();
export const useUsers = () => {
    return useContext(UsersContext);
};

export default function UsersContextProvider({ children }) {

    const [isUsers, setIsUsers] = useState()
    const [isUserById, setIsUserById] = useState()

    async function getUsers(lang) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Content-Language': lang,
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            };
            const res = await axios.get(`${newBaseUrl}/api/admin/users`, { headers });
            setIsUsers(res?.data)
            
        } catch (err) {
            console.error(err);
        }
    }

    async function getUserById(id) {
        setIsUserById()
        try {
            const headers = {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            };
            const res = await axios.get(`${newBaseUrl}/api/admin/user/${id}`, { headers });
            setIsUserById(res?.data);
            
        } catch (err) {
            console.error(err);
        }
    }

    async function deleteUser(id) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            };
            const res = await axios.delete(`${newBaseUrl}/api/admin/delete-user/${id}`, { headers });
            getUsers()
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <UsersContext.Provider value={{
            getUsers, getUserById, deleteUser, isUsers, isUserById
        }}>
            {children}
        </UsersContext.Provider>
    );
}
